/**
 * PreviewUeberMich — Über mich (about me) content page
 */

interface PreviewUeberMichProps {
  settings: {
    pageUeberMich?: {
      sections?: Record<string, boolean>;
      heroTitle?: string;
      heroSubtitle?: string;
      introText?: string;
      imageUrl?: string;
      timeline?: Array<{
        year?: string;
        title?: string;
        text?: string;
      }>;
      values?: Array<{
        icon?: string;
        title?: string;
        text?: string;
      }>;
      certifications?: string;
    };
    [key: string]: any;
  };
  components: any;
}
export function PreviewUeberMich({ settings, components }: PreviewUeberMichProps) {
  const page = settings.pageUeberMich || {};
  const sec = page.sections || {};
  const timeline = page.timeline || [];
  const values = page.values || [];
  const certs = (page.certifications || "").split(",").map(c => c.trim()).filter(Boolean);
  const hasImage = page.imageUrl && page.imageUrl.length > 0;

  return (
    <div className="content-page">
      <div className="preview-container">
        {hasImage ? (
          <section className="about-hero">
            <div className="about-hero__text">
              <h1>{page.heroTitle || "Über mich"}</h1>
              <p className="content-section__text">{page.introText || ""}</p>
            </div>
            <div className="about-hero__image">
              <img src={page.imageUrl} alt={page.heroTitle || "Über mich"} loading="lazy" />
            </div>
          </section>
        ) : (
          <>
            <section className="content-page__hero">
              <h1>{page.heroTitle || "Über mich"}</h1>
              <p>{page.heroSubtitle || ""}</p>
            </section>
            {page.introText && (
              <section className="content-section">
                <p className="content-section__text">{page.introText}</p>
              </section>
            )}
          </>
        )}

        {sec.timeline !== false && timeline.length > 0 && (
          <section className="content-section">
            <h2 className="content-section__title">Werdegang</h2>
            <div className="timeline">
              {timeline.map((item, i) => (
                <div key={i} className="timeline__item">
                  <div className="timeline__year">{item.year}</div>
                  <div className="timeline__content">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {sec.values !== false && values.length > 0 && (
          <section className="content-section">
            <h2 className="content-section__title">Werte</h2>
            <div className="values-grid">
              {values.map((val, i) => (
                <div key={i} className="value-card">
                  <div className="value-card__icon">{val.icon}</div>
                  <h3>{val.title}</h3>
                  <p>{val.text}</p>
                </div>
              ))}
            </div>
          </section>
        )}

        {sec.certifications !== false && certs.length > 0 && (
          <section className="content-section">
            <h2 className="content-section__title">Zertifizierungen</h2>
            <div className="certifications">
              {certs.map((cert, i) => (
                <span key={i} className="certification-badge">{cert}</span>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
